import request from '@/utils/request';
import { iStatisticConfig, iStatisticDetail, iResult } from '@/interface/result';
import { AxiosPromise } from 'axios';
import { eNewaddActive } from '@/interface/newadd-active';
export const getConfigLength = (params: iStatisticConfig): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/config',
    params,
  });

export const getAreaLength = (params: iStatisticConfig) =>
  request({
    url: '/api/v1/omc/statistic/area',
    params,
  });

export const getAreaDetail = (params: iStatisticDetail) =>
  request({
    url: '/api/v1/omc/statistic/area/detail',
    params,
  });

/**
 * 获取简单统计
 * @param params
 */
export const getSimple = () =>
  request({
    url: '/api/v1/omc/statistic/simple',
  });
/**
 * 获取简单统计 新接口 （数据统计-新增/活跃-用户概览）
 * @param params
 */
export const getSimpleNew = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/user/summary',
    params,
  });

/**
 * 数据统计-新增/活跃-用户留存
 * @param params
 */
export const getUserAlive = (params: { start: number; end: number; page?: number; page_size?: number; type: eNewaddActive }): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/user/alive',
    params,
  });

/**
 * 数据统计-充值/消费
 * @param params
 */
export const getChargeConsume = (params: { start: number; end: number; page?: number; page_size?: number }): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/order',
    params,
  });

/**
 * 数据统计-充值/消费汇总
 * @param params
 */
export const getTotalChargeConsume = (params: { start: number; end: number }): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/order/total',
    params,
  });
/* *
 *数据统计-节点分析
 * @param params
 */
export const getNodeAnalysis = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/node',
    params,
  });
/* *
 *数据统计-设备分布/状态-设备最高在线数
 * @param params
 */
export const getOnlineNumber = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/device/online',
    params,
  });
/* *
 *数据统计-设备分布/状态-实时状态
 * @param params
 */
export const getTimeStatus = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/device/status',
    params,
  });
/* *
 *数据统计-延迟分析
 * @param params
 */
export const getDelayTtl = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/device/ttl',
    params,
  });
/* *
 *数据统计-节点分析2分析
 * @param params
 */
export const getNodeDevice = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/statistic/node/device',
    params,
  });
